export const ChevronRight = `<svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M11.3512 6.63519L20.6488 16.0453L11.3847 25.3647" stroke="currentColor" stroke-width="2"/>
</svg>`;
